import styled, { css, keyframes } from 'styled-components'

export const fadeOut = keyframes`
0% {
    opacity: 1;
 }
 100% {
   display: none;
   opacity: 0;
 }
`

export const Container = styled.div`
    flex-direction: column-reverse;
    position: absolute;
    overflow: hidden;
    z-index: 18;
    height: 75%;
    align-items: flex-end;

    ${props => {
        const {
            showInteraction,
            isStudent,
            animate,
            studentsCount,
            isArtefactMode,
        } = props
        const positionStyles = isStudent
            ? `
                  bottom: 17%;
                  right: 3%;
              `
            : `
                  bottom: 16px;
                  right: 16px;
              `
        const disp = showInteraction ? 'flex' : 'none'
        const anim = animate
            ? css`
                  animation: 1.5s linear ${fadeOut} forwards;
                  animation-iteration-count: 1;
              `
            : null

        const align = isStudent ? 'flex-start' : 'flex-end'

        let width = 12
        width = !isStudent && studentsCount < 2 ? 6 : width
        width = !isStudent && isArtefactMode ? 10 : width

        return css`
            display: ${disp};
            ${positionStyles};
            ${anim};
            align-items: ${align};
            width: ${width}%;
        `
    }}
`

export const Button = styled.button`
    z-index: 9;
    background: #ffffff;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    outline: none;
    border: 0px;
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    display: flex;

    width: 100%;
    height: 100%;
    max-height: 40px;
    max-width: 40px;
    aspect-ratio: 1/1;

    &:hover {
        background: ${({ teacher, student, disabled }) =>
            !disabled && (student || teacher ? '#D8E9F5' : '#F0B9B9')};
    }
    &:active:hover {
        background: ${({ teacher, student, disabled }) =>
            !disabled && (student || teacher ? '#91CDF9' : '#DD2E44')};
    }
`

export const Icon = styled.img`
    height: 85%;
`

export const PieTimerWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    max-height: 40px;
    max-width: 40px;
    border-radius: 50%;
    overflow: hidden;
`

export const squareCustomCss = {
    area: css`
        position: absolute;
    `,
    wrapper: css`
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    `,
}
